export const areasOfFocus = [
    {
        "name": "Clean Water",
        "value": 1,
        "icon": "faucet",
        "iconType": "icon"
    },
    {
        "name": "Community Development",
        "value": 2,
        "icon": "images/community-development.png",
        "iconType": "image"
    },
    {
        "name": "Education",
        "value": 3,
        "icon": "book-reader",
        "iconType": "icon"
    },
    {
        "name": "Physical Health",
        "value": 4,
        "icon": "images/physical-health.png",
        "iconType": "image"
    },
    {
        "name": "Rural Health",
        "value": 5,
        "icon": "images/rural-health.png",
        "iconType": "image"
    },
    {
        "name": "Sustainable Energy",
        "value": 6,
        "icon": "images/sustainable-energy.png",
        "iconType": "image"
    },
    {
        "name": "Women / Girl Child Empowerment",
        "value": 7,
        "icon": "images/women-empowerment.png",
        "iconType": "image"
    },
    {
        "name": "Women / Girl Child Health",
        "value": 8,
        "icon": "images/women-health.png",
        "iconType": "image"
    }
]